import SubscriptionChannelPrice from "../../SubscriptionChannelPrice";
import type { IFinanceGridChannel } from "./types";

/** Channel identity: name, EAN13 when the channel has one, and subscription coefficient. */
export const ChannelCell = ({ channel }: { channel: IFinanceGridChannel }) => (
    <div className="flex flex-col">
        <span className="text-sm font-normal text-grey-900">{channel.channelName}</span>
        {channel.ean13 && <span className="text-[11px] text-foreground">EAN13 : {channel.ean13}</span>}
        {channel.subscriptionCoefficient !== undefined && (
            <span className="text-[11px]">
                <SubscriptionChannelPrice subscriptionCoefficient={channel.subscriptionCoefficient} />
            </span>
        )}
    </div>
);
